/* eslint-disable max-lines-per-function */
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {
  createDataObjectId,
  DataObjectId,
  Hub,
  SandboxTree,
  TaskTemplate,
  taskTemplatesContainerId
} from 'yougile-model'
import {SyncEvents} from '@client/sync-events'
import {Board} from '../board'
import {Project} from '../project'
import {Sticker} from '../sticker/sticker'
import {createTask} from './create-task'
import {StickersData} from './types'

export const createSiteBoard = (
  box: SandboxTree,
  project: Hub,
  stickers: StickersData,
  resDevBoard: {inProgressColId: DataObjectId}
): void | {board: Hub} => {
  const board = Project.addBoard(Lang.msg.reg.boardTeamTitle, project, false)
  if (!board) {
    return
  }

  const lang = Lang.msg.reg

  const col1 = Board.addColumn(Lang.msg.reg.boardTeamCol1, board, false)
  col1.data ??= {}
  col1.data.columnColor = {hue: 8}
  col1.commit()

  const col2 = Board.addColumn(Lang.msg.reg.boardTeamCol2, board, false)
  col2.data ??= {}
  col2.data.columnColor = {hue: 6}
  col2.commit()

  const inProgressCol = box.getHub(resDevBoard.inProgressColId)
  if (!inProgressCol) {
    return
  }
  const mirror = Board.addColumnsMirror([inProgressCol], board)
  mirror.title = 'В работе'
  mirror.commit()

  const col3 = Board.addColumn(Lang.msg.reg.boardTeamCol3, board, false)
  col3.data ??= {}
  col3.data.columnColor = {hue: 5}
  col3.commit()

  const report = new Hub(box.companyId, '')
  report.id = createDataObjectId()
  report.title = Lang.msg.reg.boardTeamCol4
  report.location = board.id
  report.data = {
    report: {
      id: report.id,
      title: Lang.msg.reg.boardTeamCol4,
      columns: [
        {
          title: '',
          filter: {
            isCompleted: {
              type: 'value',
              value: true
            },
            located: [
              {
                parent: project.id,
                subtasks: {
                  level0: true
                }
              }
            ]
          },
          activeFilters: ['isCompleted', 'located']
        }
      ],
      availableTo: []
    }
  }
  box.add(report, report.location, true, false)

  Board.getColumnsOrder(board).addEntity(report, true)

  board.data ??= {}

  board.data.settings = {
    counterInColumns: true,
    autoTaskCover: {
      checked: true
    }
  }

  board.data.stickersSettings ??= {}
  board.data.tabBgEnabled = true
  board.data.tabBgSkin = '-images/08-01'

  board.properties = {
    'show-message-stats-in-board': true
  }

  const {
    userSticker,
    deadlineTag,
    priorSticker,
    criPriorStickerStId,
    majPriorStickerStId,
    // normPriorStickerStId,
    // minPriorStickerStId,
    stopwatchSticker,
    // sprintSticker,
    // sprintStickerStId,
    taskTypeSticker,
    // featureStId,
    bugStId,
    // sectionSticker,
    commentSticker,
    deviceSticker,
    mobDeviceStickerStId,
    webDeviceStickerStId,
    mobWebDeviceStickerStId,
    estimationSticker
  } = stickers

  const {addToBoard} = Sticker

  /// Sticker: Исполнитель

  addToBoard(board, userSticker)

  /// Sticker: Дедлайн

  addToBoard(board, deadlineTag)

  /// Sticker: Приоритет

  addToBoard(board, priorSticker)

  /// Sticker: Stopwatch

  addToBoard(board, stopwatchSticker, false)
  board.data.stickersSettings[stopwatchSticker.id] = {
    shouldResetOnMove: true,
    shouldStopWhenCompleted: true
  }

  /// Sticker: Тип задачи

  addToBoard(board, taskTypeSticker)

  /// Sticker: Комментарий

  addToBoard(board, commentSticker)

  /// Sticker: Устройство

  addToBoard(board, deviceSticker, true)

  /// Sticker: Оценка в днях

  addToBoard(board, estimationSticker)
  board.data.stickersSettings[estimationSticker.id] = {
    showNumericStickersSum: true,
    titleBeforeValue: true
  }

  // Комментарий ?

  // col1 - work on concept

  const task8Col1 = createTask(lang.boardTeam.col1Task8Title, col1.id)
  task8Col1

  const task7Col1 = createTask(lang.boardTeam.col1Task7Title, col1.id)
  if (task7Col1) {
    Sticker.pin(deviceSticker, 'api', task7Col1, webDeviceStickerStId)
    Sticker.pin(commentSticker, 'api', task7Col1, 'выбор диаграммы')
  }

  const task6Col1 = createTask(lang.boardTeam.col1Task6Title, col1.id)
  task6Col1

  const task5Col1 = createTask(lang.boardTeam.col1Task5Title, col1.id)
  if (task5Col1) {
    Sticker.pin(deviceSticker, 'api', task5Col1, mobDeviceStickerStId)
  }

  const task4Col1 = createTask(lang.boardTeam.col1Task4Title, col1.id)
  task4Col1

  const task3Col1 = createTask(lang.boardTeam.col1Task3Title, col1.id)
  if (task3Col1) {
    task3Col1.data ??= {}
    task3Col1.data.color = 'task-turquoise'
    task3Col1.commit()
  }

  const task2Col1 = createTask(lang.boardTeam.col1Task2Title, col1.id)
  if (task2Col1) {
    Sticker.pin(commentSticker, 'api', task2Col1, 'отчёты')

    task2Col1.data.checklists = [
      {
        id: Util.UUID() as DataObjectId,
        title: 'Список',
        items: [
          {
            id: Util.UUID() as DataObjectId,
            isCompleted: true,
            title: 'Фильтры по времени'
          },
          {
            id: Util.UUID() as DataObjectId,
            isCompleted: true,
            title: 'Фильтры по значениям'
          },
          {
            id: Util.UUID() as DataObjectId,
            isCompleted: true,
            title: 'Фильтры по категориям'
          },
          {
            id: Util.UUID() as DataObjectId,
            isCompleted: true,
            title: 'Динамические фильтры'
          }
        ]
      }
    ]
    task2Col1.commit()
  }

  const task1Col1 = createTask(lang.boardTeam.col1Task1Title, col1.id)
  if (task1Col1) {
    Sticker.pin(priorSticker, 'api', task1Col1, majPriorStickerStId)
    Sticker.pin(deviceSticker, 'api', task1Col1, mobWebDeviceStickerStId)
  }

  // col2 - design

  const task2Col2 = createTask(lang.boardTeam.col2Task2Title, col2.id)
  if (task2Col2) {
    // Sticker.pin(userSticker, 'api', task2Col2, userId)
  }

  const task1Col2 = createTask(lang.boardTeam.col2Task1Title, col2.id)
  if (task1Col2) {
    Sticker.pin(deviceSticker, 'api', task1Col2, mobWebDeviceStickerStId)

    task1Col2.data ??= {}
    const templatePath = '/img/first-proj/cover3.jpg'
    task1Col2.data.image = templatePath
    task1Col2.commit()
  }

  // col3 - in work

  const task3Col3 = createTask(lang.boardTeam.col3Task3Title, col3.id)
  if (task3Col3) {
    Sticker.pin(deviceSticker, 'api', task3Col3, mobDeviceStickerStId)
    Sticker.pin(estimationSticker, 'api', task3Col3, '1')
  }

  const task2Col3 = createTask(lang.boardTeam.col3Task2Title, col3.id)
  if (task2Col3) {
    Sticker.pin(priorSticker, 'api', task2Col3, criPriorStickerStId)
    Sticker.pin(taskTypeSticker, 'api', task2Col3, bugStId)
    Sticker.pin(deviceSticker, 'api', task2Col3, webDeviceStickerStId)
    Sticker.pin(estimationSticker, 'api', task2Col3, '2')
  }

  const task1Col3 = createTask(lang.boardTeam.col3Task1Title, col3.id)
  if (task1Col3) {
    Sticker.pin(deviceSticker, 'api', task1Col3, webDeviceStickerStId)
    Sticker.pin(estimationSticker, 'api', task1Col3, '1')
  }

  // add task template

  const taskTemplate = new Hub(box.companyId, '')
  taskTemplate.id = createDataObjectId()
  taskTemplate.title = taskTemplate.id
  taskTemplate.location = taskTemplatesContainerId

  const data: TaskTemplate = {
    id: taskTemplate.id,
    boardId: board.id,
    title: lang.boardTeam.bugTemplate,

    subscribeUsers: [],
    enabled: true
  }
  taskTemplate.data ??= {}
  taskTemplate.data.taskTemplate = data

  box.add(taskTemplate, taskTemplate.location, true, false)

  board.data.taskTemplates = [taskTemplate.id]

  board.commit()

  setTimeout(() => {
    SyncEvents.trigger(box.companyId, [board.id], false)
  }, 1000)

  return {board}
}
